<template>
    <div>
        <div class="container">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="w-75">
                    <h5 class="float-left mr-2" v-if="!selectedFolder">Snippets</h5> <h5 class="float-left mr-2 cursor-pointer" v-else @click="backToRoot()">Snippets</h5> <h5 class="float-left mr-2 cursor-pointer" v-if="folderTree.length > 0" v-for="folderT in folderTree" @click="fetchDataOfFolder(folderT.id)">> {{folderT.name}}</h5><h5 class="float-left mr-2" v-if="folderTree.length === 0 && selectedFolder" >> {{selectedFolder.name}}</h5>
                </div>
                <div>
                    <button class="btn btn-primary" @click="newFolderModal()"><i class="fa fa-folder-o mr-2" aria-hidden="true"></i>New folder</button>
                    <button class="btn btn-primary" @click="newSnippetModal()"><i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>New snippet</button>
                </div>
            </div>
            <div class="row m-0 mb-3">
                <h6 class="text-black cursor-pointer col-1 m-0 d-flex  align-items-center" @click="backToRoot()" v-if="selectedFolder"> <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back </h6>
                <input type="text" v-model="searchText" class="form-control col-3 shadow-none" placeholder="Search snippets" @input="searchData()">
                <div class="col-3 row">
                    <label class="col-3 d-flex  align-items-center font-weight-bold m-0">Owner:</label>
                    <select class="custom-select border-0 text-black cursor-pointer col-7 focus:shadow-none " v-model="selectedFilter" @change="changeFilter()">
                        <option value="1">All</option>
                        <option value="2">Shared With Me</option>
                        <option value="3">Shared By Me</option>
                    </select>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <thead class="thead-light border-b-0">
                        <tr>
                            <th class="col-5 border-b-0">Name</th>
                            <th class="col-2 border-b-0">Created By</th>
                            <th class="col-2 border-b-0">Shared</th>
                            <th class="col-2 border-b-0">Created At</th>
                            <th class="col-1 border-b-0">Action</th>
                        </tr>
                    </thead>
                    <tbody class="border-1 border-t-0">
                        <tr class="border-t-1 cursor-pointer hover:bg-grey-lightest" v-if="allData.length > 0 && loadingData" v-for="data in allData">
                            <td class="col-5 border-0" @click="openFolderOrSnippet(data)"><i class="fa fa-folder mr-2 text-teal" v-if="data.is_folder" aria-hidden="true"></i> {{ data.name }}</td>
                            <td class="col-2 border-0">{{ data.created_by }}</td>
                            <td class="col-2 border-0"><i class="fa fa-share-alt mr-2 text-teal" aria-hidden="true" v-if="data.is_shared == 1"></i>{{ (data.is_shared == 1)? 'Shared':'Not shared' }}</td>
                            <td class="col-2 border-0">{{ formatDate(data.created_at) }}</td>
                            <td class="col-1 border-0">
                                <div v-if="user.id !== data.created_by_id" title="This item is shared with you, you can not edit this." class="snippetTooltip cursor-pointer col-6 float-left" >
                                    <i class="fa fa-pencil mr-2 text-grey" aria-hidden="true" ></i>
                                </div>
                                <div v-else title="Edit" class="snippetTooltip cursor-pointer col-6 float-left" @click="editFolderSnippet(data)">
                                    <i class="fa fa-pencil mr-2" aria-hidden="true" ></i>
                                </div>
                                <div v-if="user.id !== data.created_by_id" class="snippetTooltip cursor-pointer col-6 float-left" title="This item is shared with you, you can not delete this">
                                    <i class="fa fa-trash text-grey"  aria-hidden="true" ></i>
                                </div>
                                <div v-else-if="data.is_folder && data.item_count > 0" class="snippetTooltip cursor-pointer col-6 float-left" title="This folder has items in it, please delete them or assign them to other folder to delete this folder">
                                    <i class="fa fa-trash text-grey"  aria-hidden="true" ></i>
                                </div>
                                <div title="Delete" class="snippetTooltip cursor-pointer col-6 float-left"  v-else @click="deleteFolderSnippet(data)">
                                    <i class="fa fa-trash text-danger"  aria-hidden="true" ></i>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="allData.length === 0 && loadingData">
                            <td class="col-12 border-0 text-center" colspan="11">No snippet or folder created yet</td>
                        </tr>
                        <tr v-if="!loadingData">
                            <td class="col-12 border-0 text-center" colspan="11"><b-spinner variant="primary" label="Spinning" class="mr-2"></b-spinner> Fetching snippets and folders</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!--   New folder Modal   -->
        <snippets-new-folder-modal
            ref="SnippetNewFolderModal"
            :selected-folder-for-edit="selectedFolderForEdit"
            :all-folders="allFolders"
        ></snippets-new-folder-modal>

        <!--  New Snippet Modal -->
        <snippet-modal
            ref="SnippetModal"
            :selected-snippet-for-edit="selectedSnippetForEdit"
            :all-folders="allFolders"
        ></snippet-modal>

    </div>
</template>


<script>

import SnippetsNewFolderModal from "./snippets-new-folder-modal.vue";
import axios from "axios";
import SnippetModal from "./snippet-modal.vue";

export default {
    name: "snippets",
    props:['user'],
    components: {SnippetModal, SnippetsNewFolderModal},
    data() {
        return {
            selectedFolderForEdit: null,
            allData: [],
            allFolders: [],
            allSnippets: [],
            selectedFolder: null,
            selectedSnippetForEdit: null,
            loadingData: false,
            searchText: '',
            selectedFilter: '1',
            folderTree: [],
        };
    },
    mounted(){
        this.getData();
    },
    methods: {
        getData(){
            this.$nextTick(() => {
                this.loadingData = false;
                this.folderTree = [];
                axios.post(route('snippet.all-data'), {filter:this.selectedFilter}).then(response => {
                    this.allData = response.data.data;
                    this.allFolders = response.data.allFolders;
                    this.allSnippets = response.data.allSnippets;
                    this.selectedFolder = null;
                    this.loadingData = true;
                    setTimeout(() => {
                        $('.snippetTooltip').tooltip();
                    }, 1000)
                });
            });
        },
        newFolderModal(){
            this.$refs.SnippetNewFolderModal.newFolderModal();
        },
        newSnippetModal(){
            this.$refs.SnippetModal.newSnippetModal();
        },
        formatDate(createdAt){
            return moment.utc(createdAt).local().format('MMMM Do, YYYY h:mm A');
        },
        openFolderOrSnippet(data){
            console.log(data);
            if(data.is_folder){
                this.selectedFolder = data;
                this.fetchDataOfFolder(data.id);
            }
        },
        fetchDataOfFolder(folderId){
            this.loadingData = false;
            axios.post(route('snippet.folder.folder-data'), {folderId: folderId, filter:this.selectedFilter}).then(response => {
                this.allData = response.data.data;
                if(response.data.allSnippetFolders.length > 0){
                    this.getParentNamesAndIdsReversed(response.data.allSnippetFolders[0]);
                }else if(response.data.folder){
                    this.appendLastFolder(response.data.folder);
                }
                this.selectedFolder = response.data.folder;
                this.loadingData = true;
                setTimeout(() => {
                    $('.snippetTooltip').tooltip();
                }, 1000)
            });
        },
        backToRoot(){
            if(this.selectedFolder.parent){
                this.fetchDataOfFolder(this.selectedFolder.parent.id);
                this.selectedFolder = this.selectedFolder.parent;
            }else{
                this.folderTree = [];
                this.loadingData = false;
                this.getData();
                this.selectedFolder = null;
            }
        },
        editFolderSnippet(data){
            if(data.is_folder){
                this.selectedFolderForEdit = data;
                this.$nextTick(() => {
                    this.$refs.SnippetNewFolderModal.newFolderModal();
                })
            }else{
                this.selectedSnippetForEdit = data;
                this.$nextTick(() => {
                    this.$refs.SnippetModal.newSnippetModal();
                });
            }
        },
        deleteFolderSnippet(data){
            axios.post(route('snippet.delete'), {data: data}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.selectedFolder = null;
                this.allData = response.data.data;
                this.loadingData = true;
                setTimeout(() => {
                    $('.snippetTooltip').tooltip();
                }, 1000)
                this.getData();
            });
        },
        searchData(){
            this.$nextTick(() => {
                if(this.searchText){
                    this.loadingData = false;
                    axios.post(route('snippet.search-data'), {filter:this.selectedFilter, search: this.searchText}).then(response => {
                        this.allData = response.data.data;
                        this.selectedFolder = null;
                        this.loadingData = true;
                        setTimeout(() => {
                            $('.snippetTooltip').tooltip();
                        }, 1000)
                    });
                }else{
                    this.getData();
                }
            });
        },
        changeFilter(){
          if(this.searchText){
              this.searchData();
          }else{
              this.getData();
          }
        },
        showHideSnippetPopover(){

        },
        getParentNamesAndIdsReversed(node) {
            const result = [];

                let current = node.parent;
                while (current) {
                    result.push({ name: current.name, id: current.id });
                    current = current.parent;
                }

            this.folderTree = result.reverse();
        },
        appendLastFolder(folder){
            if(!this.folderTree.some(item => item.id === folder.id)){
                this.folderTree.push({ name: folder.name, id: folder.id });
            }
            return true;
        }

    }
};
</script>
